var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _circle3, _circle4, _path9, _circle5, _circle6, _path10, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyproblemsfbc7C07C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M28,7c-2.209,0-4,1.791-4,4v25c-1.844,0-3.299,1.664-2.947,3.57c0.217,1.179,1.176,2.146,2.353,2.372 c1.557,0.299,2.936-0.608,3.41-1.943H46c1.105,0,2-0.895,2-2V9c0-1.105-0.895-2-2-2H28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M20,40H2c-1.105,0-2-0.895-2-2V9c0-1.105,0.895-2,2-2h18c2.209,0,4,1.791,4,4v29 C24,40,22.209,40,20,40"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 16,
    r: 1,
    fill: "#1b9de2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b9de2",
    d: "M11,15c-0.186,0-5.814,0-6,0c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.186,0,5.814,0,6,0 c0.552,0,1-0.448,1-1C12,15.448,11.552,15,11,15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M35,15c-0.186,0-5.814,0-6,0c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.186,0,5.814,0,6,0 c0.552,0,1-0.448,1-1C36,15.448,35.552,15,35,15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b9de2",
    d: "M11,19c-0.186,0-5.814,0-6,0c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.186,0,5.814,0,6,0 c0.552,0,1-0.448,1-1C12,19.448,11.552,19,11,19z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b9de2",
    d: "M11,23c-0.186,0-5.814,0-6,0c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.186,0,5.814,0,6,0 c0.552,0,1-0.448,1-1C12,23.448,11.552,23,11,23z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b9de2",
    d: "M11,31c-0.186,0-5.814,0-6,0c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.186,0,5.814,0,6,0 c0.552,0,1-0.448,1-1C12,31.448,11.552,31,11,31z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b9de2",
    d: "M11,27c-0.186,0-5.814,0-6,0c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.186,0,5.814,0,6,0 c0.552,0,1-0.448,1-1C12,27.448,11.552,27,11,27z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 16,
    r: 1,
    fill: "#1b9de2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 16,
    r: 1,
    fill: "#0078d4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 16,
    r: 1,
    fill: "#0078d4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M35,19c-0.186,0-5.814,0-6,0c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.186,0,5.814,0,6,0 c0.552,0,1-0.448,1-1C36,19.448,35.552,19,35,19z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 20,
    r: 1,
    fill: "#0078d4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 20,
    r: 1,
    fill: "#0078d4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M35,23c-0.186,0-5.814,0-6,0c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.186,0,5.814,0,6,0 c0.552,0,1-0.448,1-1C36,23.448,35.552,23,35,23z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 24,
    r: 1,
    fill: "#0078d4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 20,
    r: 1,
    fill: "#1b9de2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 20,
    r: 1,
    fill: "#1b9de2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 24,
    r: 1,
    fill: "#1b9de2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 32,
    r: 1,
    fill: "#1b9de2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 28,
    r: 1,
    fill: "#1b9de2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 28,
    r: 1,
    fill: "#1b9de2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyproblemsfbc7C07C);
export default __webpack_public_path__ + "static/media/daily problems.fbc7c07c.f34dcb8ff569f8be015b506d99232ef3.svg";
export { ForwardRef as ReactComponent };